var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 2.25C13.5 1.83579 13.8358 1.5 14.25 1.5H21.75C22.1642 1.5 22.5 1.83579 22.5 2.25V9.75C22.5 10.1642 22.1642 10.5 21.75 10.5H14.25C13.8358 10.5 13.5 10.1642 13.5 9.75V2.25ZM15 3V9H21V3H15Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 6C9 5.58579 9.33579 5.25 9.75 5.25L11.25 5.25C11.6642 5.25 12 5.58579 12 6C12 6.41421 11.6642 6.75 11.25 6.75H9.75C9.33579 6.75 9 6.41421 9 6Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 3.75C1.5 3.33579 1.83579 3 2.25 3H6.75C7.16421 3 7.5 3.33579 7.5 3.75V8.25C7.5 8.66421 7.16421 9 6.75 9H2.25C1.83579 9 1.5 8.66421 1.5 8.25V3.75ZM3 4.5V7.5H6V4.5H3Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 15C17.5858 15 17.25 14.6642 17.25 14.25L17.25 12.75C17.25 12.3358 17.5858 12 18 12C18.4142 12 18.75 12.3358 18.75 12.75L18.75 14.25C18.75 14.6642 18.4142 15 18 15Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.75 22.5C15.3358 22.5 15 22.1642 15 21.75L15 17.25C15 16.8358 15.3358 16.5 15.75 16.5L20.25 16.5C20.6642 16.5 21 16.8358 21 17.25L21 21.75C21 22.1642 20.6642 22.5 20.25 22.5L15.75 22.5ZM16.5 21L19.5 21L19.5 18L16.5 18L16.5 21Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.36431 13.591C9.07142 13.2981 9.07142 12.8232 9.36431 12.5303L10.425 11.4697C10.7179 11.1768 11.1927 11.1768 11.4856 11.4697C11.7785 11.7626 11.7785 12.2374 11.4856 12.5303L10.425 13.591C10.1321 13.8839 9.65721 13.8839 9.36431 13.591Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 15.75C2.25 15.3358 2.58579 15 3 15H7.5C7.91421 15 8.25 15.3358 8.25 15.75V20.25C8.25 20.6642 7.91421 21 7.5 21H3C2.58579 21 2.25 20.6642 2.25 20.25L2.25 15.75ZM3.75 16.5V19.5H6.75V16.5H3.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChain);
export default __webpack_public_path__ + "static/media/chain.ac6f2bbdc8ba38beeea8d4d24483eeb8.svg";
export { ForwardRef as ReactComponent };